import styled from "styled-components"
import { mobile, tablet } from "../../Responsive"

export const Wrapper = styled.div`
    display: ${props => props.display};
    flex-direction: column;
    justify-content: center;
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;
`

export const Title = styled.h1`
    font-weight: 200;
`

export const Form = styled.form`
    margin-top: 15px;
`

export const StyledInputs = styled.div`
    display: flex;
    flex-wrap: wrap;
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;

    ${tablet({ width: "300px" })}
    ${mobile({ width: "250px" })}
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
`

export const StyledInput = styled.input`
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-size: var(--fontS);
    border: none;
    border-bottom: 1px solid var(--primary);
    border-radius: 5px;
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const StyledTextArea = styled.textarea`
    width: 400px;
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    border: 1px solid var(--primary);
    border-radius: 5px;
    height: 100px;

    :focus{
        border: 1px solid var(--secondary);
        outline: none;
    }

    ${tablet({ width: "300px" })}
    ${mobile({ width: "250px" })}
`

export const Message = styled.div`
`